import { STATE_STAFF_LIST } from "@fitness-force/models";

export const STAFF_STATE: STATE_STAFF_LIST = {
    staffList: [],
    staffListAll: []
}